<div class=" ptb-100">
    <div class="container" style="margin-bottom:1%">
        <div class="row">
            <div class="col-lg-3  ">
                <a routerLink="/">
                    <img src="../../../assets/images/logo.jpg" />
                </a>
            </div>
            <div class="col-lg-6">
                <div class="card">
                    <div class="row">
                        <div class="col-lg-4">
                            <div *ngIf="!isLoggedIn; else showProfileButton" routerLinkActive="active" (click)="register()">Donor register</div>
                            <ng-template #showProfileButton>
                                <div (click)="register()">My Profile</div>
                            </ng-template>
                        </div>

                        <div class="col-lg-4">
                            <div (click)="requestlogin()" routerLinkActive="active"> <div>post a blood request</div></div>
                        </div>
                        <div class="col-lg-4">
                            <div (click)="share()" routerLinkActive="active">share your services</div>
                        </div>
                    </div>
                </div>
            </div>


            <div class="col-lg-2 ">

                <ul style="float:right">
                    <li>
                        <a class="facebook" href="https://www.facebook.com/" target="_blank">

                            <i class="fab fa-facebook" aria-hidden="true"></i>
                        </a>
                    </li>
                    <li>
                        <a class="twitter" href="https://twitter.com/i/flow/login" target="_blank">

                            <i class="fab fa-twitter" aria-hidden="true"></i>
                        </a>
                    </li>
                    <li>
                        <a class="instagram" href="https://www.instagram.com/accounts/login/?hl=en" target="_blank">

                            <i class="fab fa-instagram" aria-hidden="true"></i>
                        </a>
                    </li>

                </ul>

            </div>
            <div class="col-lg-1">
                <ng-container *ngIf="LoginDetails; else showLoginButton">
                    <div class="dropdown" (click)="toggleDropdown()" style="border: 2px solid white;
               background: red;color: white;width: 50px;
                 height: 50px;border-radius: 50px; float: inline-end; ">
                        <button class="dropbtn" style="color:white">
                            {{LoginDetails[0].FullName ? LoginDetails[0].FullName.charAt(0) : '' }}

                        </button>
                        <div class="dropdown-content" style="    width:220%;">
                            <a (click)="pro()"> My Profile </a>
                            <a (click)="signOut()">Sign Out</a>
                        </div>
                    </div>
                </ng-container>
                <ng-template #showLoginButton>

                    <p class="services www" (click)="openLoginModal()" style="text-decoration:underline;cursor:pointer">  LOGIN</p>

                </ng-template>

            </div>

        </div>
    </div>


    <div class="modal" id="myModal1">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header state modal-primary">
                    <h4 style="text-align:center;color:white" class="modal-title" id="modal-primary-label">
                        Login
                    </h4>

                    <button type="button" class="close" (click)="closeModal()" data-dismiss="modal" aria-label="Close"><span aria-hidden="true" style="color:white">X</span></button>
                </div>
                <div class="modal-body">
                    <div class="container">
                        <div class="card_1">
                            <div class="row">
                                <fieldset *ngIf="EditFlag!=1">
                                    <form class="form_login">
                                        <div class="form_input">
                                            <div class="row">
                                                <div class="col-lg-2">
                                                    <label for="username">Mobile </label>
                                                </div>
                                                <div class="col-lg-8">
                                                    <input type="text" [(ngModel)]="Mobile" placeholder="Enter Your Mobile Number" id="username"
                                                           name="username" inputmode="numeric" pattern="[0-9]*" maxlength="10"
                                                           required oninput="this.value = this.value.replace(/[^0-9]/g, '');">
                                                </div>
                                                <div class="col-lg-2" (click)="EditMobileNumber()" *ngIf="OTPtoMobile != null">Edit</div>
                                                <div class="col-lg-2">
                                                    <label for="password" *ngIf="OTPtoMobile != null">OTP </label>
                                                </div>
                                                <div class="col-lg-8">
                                                    <input type="text" [(ngModel)]="OTP" id="password" name="password" *ngIf="OTPtoMobile != null" required>
                                                </div>
                                                <div class="col-lg-2"></div>
                                                <!--   <button class="btn btn-primary zoom-in1" type="submit" (click)="SendOTPtoMobile()" [hidden]="!showLogin1" [disabled]="otpSent">Send OTP</button>-->
                                            </div>


                                            <div class="col-lg-4"></div>
                                            <div class="col-lg-4">
                                                <button class="btn btn-primary zoom-in1 send" type="submit" (click)="SendOTPtoMobile()" [hidden]="!showLogin1" [disabled]="otpSent">Send OTP</button>

                                                <button class="btn btn-primary zoom-in1" type="submit" (click)="checkmobile(Mobile)" [hidden]="!showLogin">Login</button>
                                            </div>
                                        </div>
                                    </form>
                                </fieldset>
                                <fieldset *ngIf="EditFlag==1">
                                    <form class="form_login">
                                        <div class="form_input">
                                            <div class="row">
                                                <div class="col-lg-2">
                                                    <label for="username">Mobile </label>
                                                </div>
                                                <div class="col-lg-8">
                                                    <input type="text" [(ngModel)]="Mobile" placeholder="Enter Your Mobile Number" id="username"
                                                           name="username" inputmode="numeric" pattern="[0-9]*" maxlength="10"
                                                           required oninput="this.value = this.value.replace(/[^0-9]/g, '');">
                                                </div>
                                                <div class="col-lg-2" (click)="EditMobileNumber()" *ngIf="OTPtoMobile != null">Edit</div>
                                                <div class="col-lg-2">
                                                    <label for="password" *ngIf="OTPtoMobile != null">OTP </label>
                                                </div>
                                                <div class="col-lg-8">
                                                    <input type="text" [(ngModel)]="OTP" id="password" name="password" *ngIf="OTPtoMobile != null" required>
                                                </div>
                                                <div class="col-lg-2"></div>
                                                <!--   <button class="btn btn-primary zoom-in1" type="submit" (click)="SendOTPtoMobile()" [hidden]="!showLogin1" [disabled]="otpSent">Send OTP</button>-->
                                            </div>


                                            <div class="col-lg-4"></div>
                                            <div class="col-lg-4">
                                                <button class="btn btn-primary zoom-in1 send" type="submit" (click)="SendOTPtoMobile()" [hidden]="!showLogin1" [disabled]="otpSent">Send OTP</button>

                                                <button class="btn btn-primary zoom-in1" type="submit" (click)="checkmobile(Mobile)" [hidden]="!showLogin">Login</button>
                                            </div>
                                        </div>
                                    </form>
                                </fieldset>

                            </div>
                        </div>


                    </div>
                </div>
            </div>

        </div>
    </div>


    <div class="modal" id="myModal22">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header state modal-primary">
                    <h4 style="text-align:left;color:white" class="modal-title" id="modal-primary-label">
                        Eligibility Criteria
                    </h4>

                    <button type="button" class="close" (click)="closeModal()" data-dismiss="modal" aria-label="Close"><span aria-hidden="true" style="color:white">X</span></button>
                </div>
                <div class="modal-body">
                    <div class="container">
                        <div class="card_1">
                            <div class="row">
                                <div class="col-lg-12">
                                    <fieldset>

                                        Eligibility Criteria to Donate Blood
                                        <br />

                                        There are several parameters that determine the eligibility of an individual to donate blood.
                                        <br />
                                        . Overall health- The donor must be fit and healthy, and should not be suffering from transmittable diseases.
                                        <br />
                                        . Age and weight- The donor must be 18–60 years old and should weigh a minimum of 50 kg.
                                        <br />
                                        . Pulse rate- Between 50 and 100 without irregularities.
                                        <br />
                                        . Hemoglobin level- A minimum of 12.5 g/dL.
                                        <br />. Blood pressure- Diastolic: 50–100 mm Hg, Systolic: 100–180 mm Hg.
                                        <br />. Body temperature- Should be normal, with an oral temperature not exceeding 37.5 °C.
                                        <br />. The time period between successive blood donations should be more than 3 months.
                                        <br />
                                        Individuals under certain conditions are deemed ineligible to donate blood
                                        <br />
                                        . A person who has been tested HIV positive.
                                        <br />. Individuals suffering from ailments like cardiac arrest, hypertension, blood pressure, cancer, epilepsy, kidney ailments and diabetes.
                                        <br />. A person who has undergone ear/body piercing or tattoo in the past 6 months.
                                        <br />. Individuals who have undergone immunization in the past 1 month.
                                        <br />. Individuals treated for rabies or received Hepatitis B vaccine in the past 6 months.
                                        <br />. A person who has consumed alcohol in the past 24 hours.
                                        <br />. Women who are pregnant or breastfeeding.
                                        <br />. Individuals who have undergone major dental procedures or general surgeries in the past 1 month.
                                        <br />. Women who have had miscarriage in the past 6 months.
                                        <br />. Individuals who have had fits, tuberculosis, asthma and allergic disorders in the past.
                                    </fieldset>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
            </div>

        </div>
    </div>

    <div class="modal" id="myModal122">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header state modal-primary">
                    <h4 style="text-align:left;color:white" class="modal-title" id="modal-primary-label">
                        Terms and Conditions
                    </h4>

                    <button type="button" class="close" (click)="closeModal()" data-dismiss="modal" aria-label="Close"><span aria-hidden="true" style="color:white">X</span></button>
                </div>
                <div class="modal-body">
                    <div class="container">
                        <div class="card_1">
                            <div class="row">
                                <div class="col-lg-12">
                                    <fieldset>

                                        In using this Site, you agree to and understand these Terms of Use as well as our Privacy Policy. Lets- fignt website reserves the right to change the content within the web pages and within the Website Privacy Policy and Terms and Conditions at any time, without notice, at any time by updating this posting. You should visit this page periodically to review the current terms and conditions.
                                        <br />
                                        GENERAL DISCLAIMER:
                                        <br />
                                        Let's Help.com is a Non Profit, Non Commercial, ......
                                        <br />
                                        The information on this Site or otherwise communicated to users of this Site, including information communicated via e-mail is is provided solely for the Social cause and this site is Non Commercial, .
                                        We make reasonable efforts to present current and accurate information. We would not assume any legal liability and makes no representations or warranties concerning the accuracy, completeness, timeliness, reliability or usefulness of the materials accessed from or through this Site or any other site accessed through this Site. No warranty is made that the information provided is error- free. The numbers, percentages and ratios contained within the web pages may be, at any time, outdated and may include inaccuracies and/or errors.
                                        Let's Help assumes no responsibility or liability for any consequence resulting directly or indirectly from any action you take based on or made in reliance on the information or materials on this Site, or other sites linked to it. It does not represent or warrant that access to this Site or any sites linked to this Site will be uninterrupted, that this Site will operate error free. This Site or any portion thereof may be unavailable at any time
                                        <br />
                                        NOTIFICATION OF CHANGES:
                                        <br />
                                        We aim to update our site regularly, and may change the content at any time. If the need arises, we may suspend access to our site, or close it indefinitely. Any of the material on our site may be out of date at any given time, and we are under no obligation to update such material.
                                        <br />
                                        SECURITY
                                        <br />
                                        This website takes reasonable precautions to protect user information from unauthorized use or alteration. All data, correspondence, and responses that the user of the website provides will be handled confidentially, both online and offline.. Any Information Users submit via this website will not be shared nor rented, nor sold to others in any forms. All of our users’ personally identifiable information is restricted to our website only. However, the information that is needed for the Sole purpose of blood donation registration will be available for the public view. COPY RIGHT and TRADE MARKS All media (downloaded or samples), text, images, graphics, user interfaces, videos, photographs, and other content on the Site, including, but not limited to, the design, selection, arrangement, and coordination of such content on the Site, is not owned or licensed by or to Let's Help. Being a Social, Non commercial website, its been sourced through various forms from the Internet. We would like to thank all the News Channels in India, not limited to, English, Hindi or regional who has played a prominent part in building up this Website,we would like to thank Google, Wikipedia, Youtube and many more online informational sites that being a building block in making Let's Help and we assure you that none of the material will not be exploited for any commercial usage. You have been a part of our sincere endeavor of creating a good society and a social cause. If you still feel that your material, information should be deleted from this website, please feel free to send an email with the information to letsfight.ind&#64;gmail.com and we would delete it as soon as possible. REVIEWS, COMMENTS, COMMUNICATION and OTHER Site visitors may send communications; and submit suggestions, ideas, comments, questions, or other information, provided that the content is not illegal, obscene, threatening, defamatory, invasive of privacy or objectionable and does not consist of or contain software viruses, political campaigning, commercial solicitation, chain letters, mass mailings, or any form of “spam”. You may not use a false email address, impersonate any person or entity, or otherwise mislead as to the content’s origin. We have the right to disable any user identification code or password, whether chosen by you or allocated by us, at any time, if in our opinion you have failed to comply with any of the provisions of these terms of use. LINKS TO OTHER SITES This website may provide links or references to other sites. These links are provided for your convenience and Lets-help is not responsible for the content of these other sites, does not make any representations or gives any warranties with respect to any information contained in or at these other sites, and shall not be liable for any damages or injury arising from the content of these other sites.When leaving Lets-help website to visit another website, we recommend that you review that website’s terms and conditions and privacy policy. YOUR CONCERNS – TO CONTACT US If you have any questions concerning your right to the privacy and confidentiality of your personal information and data that has been entrusted to Lets-help.com website or for any specific inquiries, please contact us directly using our online contact us form Thank you for visiting our site.
                                        <br />
                                    </fieldset>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
        </div>

    </div>

    <div class="container">

        <div class="row">
            <div class="col-lg-3">
                <div class="cards" style="cursor: default;padding: 6px;">
                    Search Donor
                </div><br />
                <div class="form-group1">
                    <p-autoComplete [(ngModel)]="selectedState5"
                                    [suggestions]="deptList3"
                                    [dropdown]="true"
                                    (completeMethod)="searchCont3($event)"
                                    field="BLGName"
                                    placeholder="Search BloodGroup"
                                    (onSelect)="onStateSelect5($event)"
                                    [style]="{'color': 'black','width': '270px'}"
                                    [panelStyle]="{'background-color': 'white','width':'35rem !important', 'border': '1px solid black','margin-left':'3px'}"
                                    [autoHighlight]="false">
                    </p-autoComplete>
                </div>

                <div class="form-group1">
                    <p-autoComplete [(ngModel)]="selectedState1"
                                    [suggestions]="deptList"
                                    [dropdown]="true"
                                    (completeMethod)="searchCont($event)"
                                    field="StateName"
                                    placeholder="Search State" (click)="getDistrict()"
                                    (onSelect)="onStateSelect1($event)"
                                    [style]="{'color': 'black','width': '270px'}"
                                    [panelStyle]="{'background-color': 'white','width':'30rem !important',  'border': '1px solid black','margin-left':'3px'}"></p-autoComplete>
                </div>

              
                <div class="form-group1">
                    <p-autoComplete [(ngModel)]="selectedState2"
                                    [suggestions]="deptList1"
                                    [dropdown]="true"
                                    (completeMethod)="searchCont1($event)"
                                    field="DistrictName"
                                    placeholder="Search District" (click)="getCity()"
                                    (onSelect)="onStateSelect2($event)" [style]="{'color': 'black','width': '270px'}"
                                    [panelStyle]="{'background-color': 'white', 'border': '1px solid black','margin-left':'3px'}">

                    </p-autoComplete>
                </div>

                <div class="form-group1">
                    <p-autoComplete [(ngModel)]="selectedState3"
                                    [suggestions]="deptList2"
                                    [dropdown]="true"
                                    (completeMethod)="searchCont2($event)"
                                    field="CityName"
                                    placeholder="Search City"
                                    (onSelect)="onStateSelect3($event)"
                                    [style]="{'color': 'black', 'width': '270px'}"
                                    [panelStyle]="{'background-color': 'white', 'border': '1px solid black', 'margin-left': '3px'}">
                    </p-autoComplete>

                </div>

                <div class="form-group1">
                    <p-autoComplete [(ngModel)]="selctedpincode"
                                    [suggestions]="deptList5"
                                    [dropdown]="true"
                                    (completeMethod)="Selectcount5($event)"
                                    field="Pincode"
                                    placeholder="Search Pincode"
                                    (onSelect)="onpincodeselect($event)"
                                    [style]="{'color': 'black', 'width': '270px'}"
                                    [panelStyle]="{'background-color': 'white', 'border': '1px solid black', 'margin-left': '3px'}">
                    </p-autoComplete>

                </div>

                <div class="row">
                    <div class="col-lg-8">
                        <button class="btn1" (click)="onSearchClick($event)">Submit</button>
                    </div>


                </div>

                <br />
                <div class="cards" style="cursor: default;">
                    Learn About Blood
                </div>
                <br />
                <div class="dropdown">
                    <div class="dropbtn1">
                        <div class="blood" (click)="ComponentDropdown()">
                            Blood Components
                            <i class="fa fa-caret-down"></i>
                        </div>
                    </div>
                    <div class="dropdown-content" *ngIf="isDropdownOpen">
                        <div class="listitem" routerLink="/BloodComponents">  Whole Blood and Red Blood Cells</div>
                        <div class="listitem" routerLink="/BloodComponents">  Platelets</div>
                        <div class="listitem" routerLink="/BloodComponents"> Plasma</div>
                        <div class="listitem" routerLink="/BloodComponents"> White Blood Cells and Granulocytes</div>

                    </div>
                </div>

                <div class="dropdown">
                    <div class="dropbtn1">
                        <div class="blood" (click)="ComponentDropdown2()">
                            Blood Transfusion
                            <i class="fa fa-caret-down"></i>
                        </div>
                    </div>
                    <div class="dropdown-content" *ngIf="isDropdownOpen2">
                        <div class="listitem" routerLink="/BloodTransfusion">  Types of Blood Transfusions</div>
                        <div class="listitem" routerLink="/BloodTransfusion"> Reasons for Blood Transfusions</div>
                        <div class="listitem" routerLink="/BloodTransfusion"> The Process</div>
                        <div class="listitem" routerLink="/BloodTransfusion"> Risks and Complications</div>

                    </div>

                </div>

                <div class="dropdown">
                    <div class="dropbtn1">
                        <div class="blood" (click)="ComponentDropdown3()">
                            Iron And Blood Donation
                            <i class="fa fa-caret-down"></i>
                        </div>
                    </div>
                    <div class="dropdown-content" *ngIf="isDropdownOpen3">
                        <div class="listitem" routerLink="/IronBloodDonation">Iron Info. for All Donors</div>
                        <div class="listitem" routerLink="/IronBloodDonation"> Iron Info. for Frequent Donors</div>
                        <div class="listitem" routerLink="/IronBloodDonation">Donors Deferred for Low Hemoglobin </div>
                        <div class="listitem" routerLink="/IronBloodDonation">Blood Types</div>
                    </div>
                </div>

                <div class="dropdown">
                    <div class="dropbtn1">
                        <div class="blood" (click)="ComponentDropdown4()">
                            Blood And Diversity
                            <i class="fa fa-caret-down"></i>
                        </div>
                    </div>
                    <div class="dropdown-content" *ngIf="isDropdownOpen4">
                        <div class="listitem" routerLink="/BloodDiversity">Rare Donor Program</div>

                    </div>
                </div>

                <div class="dropdown">
                    <div class="dropbtn1">
                        <div class="blood" (click)="ComponentDropdown5()">
                            Health And Wellness
                            <i class="fa fa-caret-down"></i>
                        </div>
                    </div>
                    <div class="dropdown-content" *ngIf="isDropdownOpen5">
                        <div class="listitem" routerLink="/HealthWellness">Iron Rich Foods</div>

                    </div>
                </div>

            </div>

            <div class="col-lg-6">

                <form *ngIf="isDonorRegisterClicked" class="form_login">
                    <div class="Loginn"> </div>
                    <div class="row">
                        <div class="col-lg-4">
                            <label for="username">Mobile </label>
                        </div>
                        <div class="col-lg-7">
                            <input type="text" [(ngModel)]="Mobile" placeholder="Enter Your Mobile Number" id="username" name="username" inputmode="numeric" pattern="[0-9]*" maxlength="10" required oninput="this.value = this.value.replace(/[^0-9]/g, '');" [disabled]="isMobileDisabled"
                                   (input)="checkMobileLength($event)">
                        </div>
                        <div class="col-lg-1" style="cursor:pointer;" (click)="EditMobileNumber()" *ngIf="OTPtoMobile != null">Edit</div>

                        <div class="col-lg-4">
                            <label for="password" *ngIf="OTPtoMobile != null">OTP </label>
                        </div>
                        <div class="col-lg-7">
                            <input type="text" inputmode="numeric" pattern="[0-9]*" maxlength="4" required oninput="this.value = this.value.replace(/[^0-9]/g, '');" [(ngModel)]="OTP" id="password" name="password" *ngIf="OTPtoMobile != null" placeholder="Enter your OTP" required>
                        </div>
                        <div class="col-lg-4"></div>
                        <div class="col-lg-8">
                            <button class="btn btn-primary send" type="submit" (click)="SendOTPtoMobile()" [hidden]="!showLogin1" [disabled]="otpSent">Send OTP</button>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-lg-4"></div>
                        <div class="col-lg-8">
                            <button class="btn btn-primary" type="submit" (click)="checkmobile(Mobile)" [hidden]="!showLogin">Sign in</button>
                        </div>
                    </div>


                </form>

                <form *ngIf="isDonorRegisterClickedd" class="form_login">
                    <div class="form_input">
                        <div class="Loginn"></div>
                        <div class="row">
                            <div class="col-lg-4">
                                <label for="username">Mobile </label>
                            </div>
                            <div class="col-lg-7">
                                <input type="text" [(ngModel)]="Mobile" placeholder="Enter Your Mobile Number" id="username" name="username" inputmode="numeric" pattern="[0-9]*" maxlength="10" required oninput="this.value = this.value.replace(/[^0-9]/g, '');" [disabled]="isMobileDisabled"
                                       (input)="checkMobileLength($event)">
                            </div>
                            <div class="col-lg-1" style="cursor:pointer;" (click)="EditMobileNumber()" *ngIf="OTPtoMobile != null">Edit</div>
                            <div class="col-lg-4">
                                <label for="password" *ngIf="OTPtoMobile != null">OTP </label>
                            </div>
                            <div class="col-lg-7">
                                <input type="text" inputmode="numeric" pattern="[0-9]*" maxlength="4" required oninput="this.value = this.value.replace(/[^0-9]/g, '');" [(ngModel)]="OTP" id="password" name="password" *ngIf="OTPtoMobile != null" placeholder="Enter your OTP" required>
                            </div>
                            <div class="col-lg-4"></div>
                            <div class="col-lg-8">
                                <button class="btn btn-primary" type="submit" (click)="SendOTPtoMobile()" [hidden]="!showLogin1" [disabled]="otpSent">Send OTP</button>

                            </div>
                            <div class="col-lg-4"></div>
                            <div class="col-lg-8">

                                <button class="btn btn-primary" type="submit" (click)="checkmobile1(Mobile)" [hidden]="!showLogin">Sign in</button>

                            </div>
                        </div>
                    </div>
                </form>


                <div id="carouselExampleFade" class="carousel slide carousel-fade" data-ride="carousel" *ngIf="!isDonorRegisterClickedd  && !isDonorRegisterClicked && !isRegistrationFormVisible && !isprofileFormVisible && !isshareFormVisible && !isrequestFormVisible">
                    <div class="carousel-inner">
                        <div class="carousel-item active">
                            <img src="../../../assets/images/slider/bg1.jpg" alt="Blood Donation" class="d-block w-100">
                        </div>
                        <div class="carousel-item">
                            <img src="../../../assets/images/slider/bg2.jpg" class="d-block w-100" alt="Blood Donation">
                        </div>
                        <div class="carousel-item">
                            <img src="../../../assets/images/slider/bg3.jpg" class="d-block w-100" alt="Blood Donation">
                        </div>
                    </div>
                    <a class="carousel-control-prev" href="#carouselExampleFade" role="button" data-slide="prev">
                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span class="sr-only">Previous</span>
                    </a>
                    <a class="carousel-control-next" href="#carouselExampleFade" role="button" data-slide="next">
                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                        <span class="sr-only">Next</span>
                    </a>
                </div>
                <div style="margin-top:3%">

                    <!--<marquee *ngIf="!isDonorRegisterClickedd &&!isDonorRegisterClicked && !isRegistrationFormVisible && !isprofileFormVisible && !isshareFormVisible && !isrequestFormVisible"><h6 style="text-align:center;color:red;font-weight:bold">"Be a hero. Donate blood."</h6></marquee>-->
                    <br />    <p class="fade-in-out justified-text" *ngIf="!isDonorRegisterClickedd  && !isDonorRegisterClicked && !isRegistrationFormVisible && !isprofileFormVisible && !isshareFormVisible && !isrequestFormVisible">
                        "Blood donation is the real act of humanity. It costs nothing but saves a life!"

                    </p>
                    <p class="fade-in-out justified-text" *ngIf="!isDonorRegisterClickedd && !isDonorRegisterClicked && !isRegistrationFormVisible && !isprofileFormVisible && !isshareFormVisible && !isrequestFormVisible">
                        "Donating blood is not just giving blood, it’s giving life."
                    </p>
                    <p class="fade-in-out justified-text" *ngIf="!isDonorRegisterClickedd  && !isDonorRegisterClicked && !isRegistrationFormVisible && !isprofileFormVisible && !isshareFormVisible && !isrequestFormVisible">
                        "Every drop of blood is like a breath for someone out there. Donate and let them breathe."

                    </p>
                    <p class="fade-in-out justified-text" *ngIf="!isDonorRegisterClickedd && !isDonorRegisterClicked && !isRegistrationFormVisible && !isprofileFormVisible && !isshareFormVisible && !isrequestFormVisible">
                        "Blood donation is not just an act of charity; it is an act of solidarity."
                    </p>
                    <p class="fade-in-out justified-text" *ngIf="!isDonorRegisterClickedd && !isDonorRegisterClicked && !isRegistrationFormVisible && !isprofileFormVisible && !isshareFormVisible && !isrequestFormVisible">
                        "Be a hero, give blood and save lives."
                    </p>
                </div>

                <!--register-------------------------------------->

                <form class="form_2" [formGroup]="form" (ngSubmit)="Donersform()" *ngIf="isRegistrationFormVisible">
                    <div >
                        <!--<header class="pane-header__content">
                <h2 class="page-title u-white" style="line-height: 60PX;">Login/Registration</h2>
                <p class="para">Whether you have an existing account or a new registrant, your online account will allow you to do the following:</p>
                <p class="para">1. Become a blood donor and start saving life..!(Select, willing to donate blood)</p>
                <p class="para">2. Post a Blood request.</p>
                <p class="para">3. Search and view the donor contact information. </p>
                <p class="para"> 4. View the contact info of the Old age, Blood Banks and Orphan Homes in India.  </p>
                <p class="para"> 5. Comment, Share and Vote on the social issues. </p>
            </header>-->
                        <br />

                        <div class="row" style=" height: 233px; overflow-y: scroll;">

                            <div class="row">
                                <div class="col-lg-11 mt-3">
                                    <span><b><span class="note">Note :</span> Enable or disable the visibility of your details to the public for donation</b></span>
                                </div>
                                <div class="col-lg-1 mt-3">
                                    <label class="switch">
                                        <input type="checkbox" formControlName="Status" id="Status" [checked]="form.get('Status').value" (change)="toggleStatuss($event.target.checked)">
                                        <span class="slider"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="row">

                                <div class="col-lg-11 mt-3">
                                    <span><b><span class="note">Note :</span> Enable or disable the visibility of your phone number to the public for donation</b></span>
                                </div>
                                <div class="col-lg-1 mt-3">
                                    <label class="switch">
                                        <input type="checkbox" formControlName="Statusphn" id="Status"
                                               [checked]="form.get('Statusphn').value"
                                               (change)="toggleStatuss1($event.target.checked)">
                                        <span class="slider"></span>
                                    </label>
                                </div>


                            </div>
                            <div class="col-lg-4">
                                <label for="username">Full Name<span style="color:red">*</span></label>
                            </div>
                            <div class="col-lg-8">
                                <input type="text" id="username" formControlName="username" placeholder="Donor Full Name" />
                                <small style="color:red" class="text-danger" *ngIf="form.controls.username.touched && form.controls.username.errors?.required">Donor Name is required</small>

                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-4">
                                <label for="mobile">Mobile&nbsp;Number<span style="color:red">*</span></label>
                            </div>
                            <div class="col-lg-8">
                                <input type="text" id="mobile" formControlName="mobile" placeholder="Mobile Number" [readonly]="true" />
                                <small style="color:red" class="text-danger" *ngIf="form.controls.mobile.touched && form.controls.mobile.errors?.required">Donor Mobile is required</small>

                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-4">
                                <label for="email">Email<span style="color:red">*</span></label>
                            </div>
                            <div class="col-lg-8">
                                <input type="text" id="email" formControlName="email" placeholder="Email ID" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-4">
                                <label for="age">Gender<span style="color:red">*</span></label>
                            </div>
                            <div class="col-lg-8">
                                <div class="row">
                                    <div class="col-lg-3 col-xs-6">
                                        <div class="chip1" (click)="selectGender('Male')" [ngClass]="{'selected': selectedGender === 'Male'}" required>Male</div>
                                    </div>
                                    <div class="col-lg-3 col-xs-6">
                                        <div class="chip1" (click)="selectGender('Female')" [ngClass]="{'selected': selectedGender === 'Female'}" required>Female</div>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-4">
                                <label for="age">Ever donated blood<span style="color:red">*</span></label>
                            </div>
                            <div class="col-lg-8">
                                <div class="row">
                                    <div class="col-lg-3 col-xs-6">
                                        <div class="chip1" (click)="PastDonation('Yes')" [ngClass]="{'selected': selectedpast === 'Yes'}" required>Yes</div>

                                    </div>
                                    <div class="col-lg-3 col-xs-6">
                                        <div class="chip1" (click)="PastDonation('No')" [ngClass]="{'selected': selectedpast === 'No'}" required>No</div>

                                    </div>
                                    <div class="col-lg-4 col-xs-6"></div>
                                </div>

                            </div>
                            <div class="col-lg-4" *ngIf="selectedpast !== 'No'">
                                <label>Last donate date<span style="color:red">*</span></label>
                            </div>
                            <div class="col-lg-8" *ngIf="selectedpast !== 'No'">
                                <div class="input-group">
                                    <input class="txtDate" formControlName="Lastdonatedate" type="date" name="Lastdonatedate" id="Lastdonatedate" [readonly]="selectedpast === 'No'">
                                </div>
                            </div>

                        </div>

                        <div class="row">
                            <div class="col-lg-4">
                                <label style="margin-top:-0.5rem;" for="mobile">Weight<span style="color:red">*</span></label>
                            </div>

                            <div class="col-lg-8">
                                <input style="margin-top:-0.5rem;" type="text" id="Weight" formControlName="Weight" placeholder="Weight " oninput="this.value = this.value.replace(/[^0-9]/g, '');" />
                                <small style="color:red" class="text-danger" *ngIf="form.controls.Weight.touched && form.controls.Weight.errors?.required">Doner Weight is required</small>

                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-4">
                                <label for="age">Age<span style="color:red">*</span></label>
                            </div>
                            <div class="col-lg-8">
                                <input type="text" id="age" formControlName="age" placeholder="Age" oninput="this.value = this.value.replace(/[^0-9]/g, '');" />
                            </div>
                        </div>



                        <div class="row">
                            <div class="col-lg-4">
                                <label>Blood Group<span style="color:red">*</span></label>
                            </div>
                            <div class="col-lg-8">
                                <div style="padding-left:0px">

                                    <p-autoComplete formControlName="bloodgroup" [suggestions]="deptList3" (completeMethod)="searchCont3($event)"
                                                    field="BLGName" [dropdown]="true" [size]="90"
                                                    placeholder="Search Patient blood group" [minLength]="1"
                                                    [style]="{'color': 'black'}"
                                                    [panelStyle]="{'background-color': 'white','margin-left':'3px','padding':'10px','box-shadow':' rgba(0, 0, 0, 0.24) 0px 3px 8px',}">
                                    </p-autoComplete>

                                    <small *ngIf="form.controls.bloodgroup.touched && form.controls.bloodgroup.errors?.required"
                                           class="p-error">blood group is required.</small>
                                </div>
                            </div>
                        </div>

                        <div class="row">

                            <div class="col-lg-4">
                                <label>State Name</label>
                            </div>
                            <div class="col-lg-8">

                                <div style="padding-left:0px">

                                    <p-autoComplete formControlName="statename" [suggestions]="deptList" (completeMethod)="searchCont111($event)"
                                                    field="StateName" [dropdown]="true" [size]="90" (click)="getDistrict111()"
                                                    placeholder="Search State Name" [minLength]="1"
                                                    [style]="{'color': 'black'}"
                                                    [panelStyle]="{'background-color': 'white', 'box-shadow':' rgba(0, 0, 0, 0.24) 0px 3px 8px','margin-left':'3px','padding':'10px','cursor':'pointer',}">

                                    </p-autoComplete>

                                    <small *ngIf="form.controls.statename.touched && form.controls.statename.errors?.required"
                                           class="p-error">State Name is required.</small>
                                </div>

                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-4">
                                <label>District Name</label>
                            </div>
                            <div class="col-lg-8">

                                <div style="padding-left:0px">

                                    <p-autoComplete formControlName="districtname" [suggestions]="deptList1" (completeMethod)="searchCont112($event)"
                                                    field="DistrictName" [dropdown]="true" [size]="90" (click)="getCity111()"
                                                    placeholder="Search District Name" [minLength]="1"
                                                    [style]="{'color': 'black'}"
                                                    [panelStyle]="{'background-color': 'white', 'box-shadow':' rgba(0, 0, 0, 0.24) 0px 3px 8px','margin-left':'3px','padding':'10px'}">

                                    </p-autoComplete>

                                    <small *ngIf="form.controls.districtname.touched && form.controls.districtname.errors?.required"
                                           class="p-error">District Name is required.</small>
                                </div>
                            </div>

                        </div>

                        <div class="row">
                            <div class="col-lg-4">
                                <label>City Name</label>
                            </div>
                            <div class="col-lg-8">
                                <div style="padding-left:0px">

                                    <p-autoComplete formControlName="cityname"
                                                    [suggestions]="deptList2"
                                                    (completeMethod)="searchCont222($event)"
                                                    field="CityName"
                                                    [dropdown]="true"
                                                    [size]="120"
                                                    placeholder="Search City Name"
                                                    [minLength]="1"
                                                    [style]="{'color': 'black'}"
                                                    [panelStyle]="{'background-color': 'white', 'box-shadow':' rgba(0, 0, 0, 0.24) 0px 3px 8px','margin-left':'3px','padding':'10px',}">
                                    </p-autoComplete>


                                    <small *ngIf="form.controls.cityname.touched && form.controls.cityname.errors?.required"
                                           class="p-error">City Name is required.</small>
                                </div>

                            </div>

                        </div>

                        <div class="row">
                            <div class="col-lg-4">
                                <label for="useraddress">User Address</label>
                            </div>
                            <div class="col-lg-8">
                                <!--<input type="text" class="form-control" [(ngModel)]="useraddress" (keydown.enter)="$event.preventDefault()" placeholder="Search Nearest Location" autocorrect="off" autocapitalize="off" spellcheck="off" type="text" #search>-->

                                <input type="text" id="useraddress" formControlName="useraddress" placeholder="User Address" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-4">
                                <label for="area">Area</label>
                            </div>
                            <div class="col-lg-8">
                                <input type="text" id="area" formControlName="area" placeholder="Area" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-4">
                                <label for="mobile">Pincode<span style="color:red">*</span></label>
                            </div>

                            <div class="col-lg-8">
                                <input type="text" id="Pincode" formControlName="Pincode" [maxlength]="6" placeholder="Pincode " oninput="this.value = this.value.replace(/[^0-9]/g, '');" />
                                <small style="color:red" class="text-danger" *ngIf="form.controls.Pincode.touched && form.controls.Pincode.errors?.required">Pincode is required</small>

                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-4">
                                <label for="area">Message to blood Requester</label>
                            </div>
                            <div class="col-lg-8">
                                <input type="text" id="Messagetorequester" formControlName="Messagetorequester" placeholder="Message to blood requester" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-3"></div>
                            <div class="col-lg-1">
                                <input type="checkbox" formControlName="termsAndConditions" style="display: inline; float: right; margin-left: 8px; " (change)="checkFormValidity()"><span style="color:red">*</span>
                            </div>
                            <div class="col-lg-8" (click)="opent()">
                                <div style="cursor:pointer;">I Agree to the terms and conditions of the website</div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-3"></div>
                            <div class="col-lg-1">
                                <input type="checkbox" formControlName="eligibilityCriteria" style="display:inline;float:right;margin-left:8px; " (change)="checkFormValidity()"><span style="color:red">*</span>
                            </div>
                            <div class="col-lg-8" (click)="openC()">
                                <div style="cursor:pointer;">I Have read the eligibility criteria and confirm that I am eligible to Donate blood</div>
                            </div>
                        </div>
                        <div class="col-lg-11" *ngIf="((LoginDetails[0]?.RoleId === 4) || (LoginDetails[0]?.RoleId === 0)) && ((LoginDetails[0]?.Rolestatus === false) || (LoginDetails[0]?.Rolestatus === true) || (LoginDetails[0]?.Rolestatus === false))">
                            <span><b><span class="note">Note:</span> Enable or disable to become as a Leader</b></span>
                        </div>
                        <div class="col-lg-1" *ngIf="((LoginDetails[0]?.RoleId === 4) || (LoginDetails[0]?.RoleId === 0)) && ((LoginDetails[0]?.Rolestatus === false) || (LoginDetails[0]?.Rolestatus === true) || (LoginDetails[0]?.Rolestatus === false))">
                            <label class="switch">
                                <input type="checkbox" formControlName="Rolestatus" id="Status" [checked]="form3.get('Rolestatus').value" (change)="toggleStatuss2($event.target.checked)">
                                <span class="slider"></span>
                            </label>
                        </div>


                        <br />
                        <div style="text-align: center;">
                            <!--<button class="btn">Submit</button>-->
                            <button type="submit" style="cursor:pointer;" class="btn" [disabled]="!form.valid">Submit</button>
                        </div>
                    </div>

                </form>
                <!--register end----------------->
                <!--request form------------start---------->
                <form [formGroup]="form2" (ngSubmit)="Requestform()" *ngIf="isrequestFormVisible">
                    <div >
                        <div class="row">
                            <div class="col-lg-4">
                                <label for="username">Contact Person<span style="color:red">*</span></label>
                            </div>
                            <div class="col-lg-8">
                                <input type="text" id="username" formControlName="contactperson" placeholder="Contact Person Full Name" />
                                <small style="color:red" class="text-danger" *ngIf="form2.controls.contactperson.touched && form2.controls.contactperson.errors?.required">Contact Person Name is required</small>

                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-4">
                                <label for="mobile">Mobile&nbsp;Number<span style="color:red">*</span></label>
                            </div>
                            <div class="col-lg-8">
                                <input type="text" id="Contmobile" formControlName="Contmobile" inputmode="numeric" pattern="[0-9]*" maxlength="10" placeholder="Patient Attender Mobile Number" />
                                <small style="color:red" class="text-danger" *ngIf="form2.controls.Contmobile.touched && form2.controls.Contmobile.errors?.required">Attender Mobile is required</small>
                            </div>
                        </div>
                        <div class="patient">
                            <div class="row">
                                <div class="col-lg-4"></div>
                                <div class="col-lg-4"> <b class="center_text">Patient Information </b></div>
                                <div class="col-lg-4"></div>

                            </div>
                        </div><br />
                        <div class="row">
                            <div class="col-lg-4">
                                <label for="username">Patient Name<span style="color:red">*</span></label>
                            </div>
                            <div class="col-lg-8">
                                <input type="text" id="username" formControlName="username" placeholder="Paitent Full Name" />
                                <small style="color:red" class="text-danger" *ngIf="form2.controls.username.touched && form2.controls.username.errors?.required">Patient Name is required</small>

                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-4">
                                <label for="email">Email</label>
                            </div>
                            <div class="col-lg-8">
                                <input type="text" id="email" formControlName="email" placeholder="Patient Attender Email ID" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-4">
                                <label for="age">Gender<span style="color:red">*</span></label>
                            </div>
                            <div class="col-lg-8">
                                <div class="row">
                                    <div class="col-lg-6">
                                        <div class="chip1" (click)="selectGenders('Male')" [ngClass]="{'selected': selectedGenders === 'Male'}">Male</div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="chip1" (click)="selectGenders('Female')" [ngClass]="{'selected': selectedGenders === 'Female'}">Female</div>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-4">
                                <label for="age">Patient Age <span style="color:red">*</span></label>
                            </div>
                            <div class="col-lg-8">
                                <input type="text" id="age" formControlName="age" placeholder="Age" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-4">
                                <label for="useraddress">Patient&nbsp;Location<span style="color:red">*</span></label>
                            </div>
                            <div class="col-lg-8">
                                <input type="text" id="useraddress" formControlName="useraddress" placeholder="Patient Address" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-4">
                                <label for="age">Required&nbsp;Date<span style="color:red">*</span></label>
                            </div>
                            <div class="col-lg-8">
                                <input type="date" style=" border-radius: 5px; margin: 5px 0px 12px 0px;" formControlName="BloodRequestDate" id="BloodRequestDate" placeholder="Blood Required Date">
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-4">
                                <label for="age">Required&nbsp;Time<span style="color:red">*</span></label>
                            </div>
                            <div class="col-lg-8">
                                <input type="time" style=" border-radius: 5px; margin: 5px 0px 12px 0px;" formControlName="RequestTime" id="RequestTime" placeholder="Blood Required Time">
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-4">
                                <label>Blood&nbsp;Group <span style="color:red">*</span></label>
                            </div>
                            <div class="col-lg-8">
                                <div style="padding-left:0px">

                                    <p-autoComplete formControlName="bloodgroup" [suggestions]="deptList3" (completeMethod)="searchCont3($event)"
                                                    field="BLGName" [dropdown]="true" [size]="90"
                                                    placeholder="Search Patient blood group" [minLength]="1"
                                                    [style]="{'color': 'black'}"
                                                    [panelStyle]="{'background-color': 'white','margin-left':'3px','padding':'10px','box-shadow':' rgba(0, 0, 0, 0.24) 0px 3px 8px',}">
                                    </p-autoComplete>

                                    <small *ngIf="form2.controls.bloodgroup.touched && form2.controls.bloodgroup.errors?.required"
                                           class="p-error">Patient blood group is required.</small>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-4">
                                <label for="bloodgroup">Units&nbsp;of&nbsp;blood<span style="color:red">*</span></label>
                            </div>
                            <div class="col-lg-8">
                                <p-autoComplete formControlName="unitsofblood" [suggestions]="deptList4" (completeMethod)="searchCont4($event)"
                                                field="UnitsofBlood" [dropdown]="true" [size]="90" placeholder="Search units of blood" [minLength]="1"
                                                [style]="{'color': 'black'}"
                                                [panelStyle]="{'background-color': 'white','margin-left':'3px','padding':'10px','box-shadow':' rgba(0, 0, 0, 0.24) 0px 3px 8px',}">

                                </p-autoComplete>
                                <small *ngIf="form2.controls.unitsofblood.touched && form2.controls.unitsofblood.errors?.required" class="p-error">
                                    units of blood is required.
                                </small>
                            </div>
                        </div>

                        <div class="row">
                            <div class="row">
                                <div class="col-lg-4">
                                    <label for="useraddress">Doctor&nbsp;Name</label>
                                </div>
                                <div class="col-lg-8">
                                    <input type="text" id="DoctorName" formControlName="DoctorName" placeholder="DoctorName/Optional" class="Dname" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-4">
                                    <label for="area">Purpose</label>
                                </div>
                                <div class="col-lg-8">
                                    <input type="text" id="Purpose" formControlName="Purpose" placeholder="Purpose of blood" class="Dname" />
                                </div>
                            </div>

                            <div class="patient" style="margin-bottom:4%">
                                <div class="row">
                                    <div class="col-lg-4"></div>
                                    <div class="col-lg-4"><b class="center_text"> Location of Donation</b></div>
                                    <div class="col-lg-4"></div>
                                </div>

                            </div><br />

                            <div class="col-lg-4">
                                <label for="category">Search Hospital<span style="color:red">*</span></label>
                            </div>
                            <div class="col-lg-8">
                                <p-autoComplete formControlName="HsptName" [suggestions]="deptList8" (completeMethod)="searchCont8($event)"
                                                field="HsptName" [dropdown]="true" [size]="90"
                                                placeholder="Select Hospital" [minLength]="1"
                                                [style]="{'color': 'black'}"
                                                [panelStyle]="{'background-color': 'white','margin-left':'3px','padding':'10px','box-shadow':' rgba(0, 0, 0, 0.24) 0px 3px 8px',}">
                                </p-autoComplete>
                                <small *ngIf="form2.controls.HsptName.touched && form2.controls.HsptName.errors?.required"
                                       class="p-error" style="color:red">Hospital Name is required.</small>
                            </div>

                            <div class="col-lg-4">
                                <label for="useraddress">Hospital Number</label>
                            </div>
                            <div class="col-lg-8 ml-n2">
                                <input type="text" id="HospitalPhonenumber" formControlName="HospitalPhonenumber" placeholder="Hospital Number" class="Dname" />
                            </div>

                            <div class="col-lg-4">
                                <label for="area">Hospital Address</label>
                            </div>
                            <div class="col-lg-8 ml-n2">
                                <input type="text" id="HospitalAddress" formControlName="HospitalAddress" placeholder="Hospital Address" class="Dname" />
                            </div>

                            <div class="col-lg-4">
                                <label>State Name</label>
                            </div>
                            <div class="col-lg-8">

                                <div style="padding-left:0px">

                                    <p-autoComplete formControlName="statename" [suggestions]="deptList" (completeMethod)="searchCont11($event)"
                                                    field="StateName" [dropdown]="true" [size]="90" (click)="getDistrict1()"
                                                    placeholder="Search State Name" [minLength]="1"
                                                    [style]="{'color': 'black'}"
                                                    [panelStyle]="{'background-color': 'white', 'box-shadow':' rgba(0, 0, 0, 0.24) 0px 3px 8px','margin-left':'3px','padding':'10px','cursor':'pointer',}">

                                    </p-autoComplete>

                                    <small *ngIf="form2.controls.statename.touched && form2.controls.statename.errors?.required"
                                           class="p-error">State Name is required.</small>
                                </div>

                            </div>

                            <div class="col-lg-4">
                                <label>District</label>
                            </div>
                            <div class="col-lg-8">

                                <div style="padding-left:0px">

                                    <p-autoComplete formControlName="districtname" [suggestions]="deptList1" (completeMethod)="searchCont12($event)"
                                                    field="DistrictName" [dropdown]="true" [size]="90" (click)="getCity1()"
                                                    placeholder="Search District Name" [minLength]="1"
                                                    [style]="{'color': 'black'}"
                                                    [panelStyle]="{'background-color': 'white', 'box-shadow':' rgba(0, 0, 0, 0.24) 0px 3px 8px','margin-left':'3px','padding':'10px'}">

                                    </p-autoComplete>

                                    <small *ngIf="form2.controls.districtname.touched && form2.controls.districtname.errors?.required"
                                           class="p-error">District Name is required.</small>
                                </div>
                            </div>



                            <div class="col-lg-4">
                                <label>City</label>
                            </div>
                            <div class="col-lg-8">
                                <div style="padding-left:0px">

                                    <p-autoComplete formControlName="cityname"
                                                    [suggestions]="deptList2"
                                                    (completeMethod)="searchCont22($event)"
                                                    field="CityName"
                                                    [dropdown]="true"
                                                    [size]="120"
                                                    placeholder="Search CityName"
                                                    [minLength]="1"
                                                    [style]="{'color': 'black'}"
                                                    [panelStyle]="{'background-color': 'white', 'box-shadow':' rgba(0, 0, 0, 0.24) 0px 3px 8px','margin-left':'3px','padding':'10px',}">
                                    </p-autoComplete>


                                    <small *ngIf="form2.controls.cityname.touched && form2.controls.cityname.errors?.required"
                                           class="p-error">City Name is required.</small>
                                </div>

                            </div>


                            <div class="col-lg-4">
                                <label for="area">Patient&nbsp;Area</label>
                            </div>
                            <div class="col-lg-8">
                                <input type="text" id="area" formControlName="area" placeholder="Patient Area" />
                            </div>


                            <div class="col-lg-4">
                                <label for="mobile">Pincode<span style="color:red">*</span></label>
                            </div>
                            <br />
                            <div class="col-lg-8">
                                <input type="text" id="Pincode" required formControlName="Pincode" placeholder="Pincode" maxlength="6" min="5" oninput="this.value = this.value.replace(/[^0-9]/g, '');" />
                                <small style="color:red" class="text-danger" *ngIf="form.controls.Pincode.touched && form.controls.Pincode.errors?.required">Pincode is required</small>

                            </div>


                            <div class="col-lg-4">
                                <label for="area">Message</label>
                            </div>
                            <div class="col-lg-8">
                                <input type="text" id="PersonalNote" formControlName="PersonalNote" placeholder="Message Your Personal Note" />
                            </div>


                            <br />
                            <div class="row">
                                <div class="col-lg-4"></div>
                                <div class="col-lg-4">  <button style="cursor:pointer;" class="btn">Submit</button></div>
                                <div class="col-lg-4"></div>

                            </div>
                        </div>
                    </div>
                </form>
                <!--request form------------request form end---------->
                <!--Profileeeeeeeeeeeeeeeeeeee---------------->
                <form class="form_1" [formGroup]="form3" (ngSubmit)="Donersforms()" *ngIf="isprofileFormVisible">
                    <div>
                        <div class="row">

                            <div class="row" *ngIf="form3.controls['Rolestatus'].value && LoginDetails[0].RoleId === 4 || LoginDetails[0].RoleId !== 4">

                                <div class="col-lg-11">
                                    <span><b><span class="note">Note :</span> Enable or disable the visibility of your details to the public for donation</b></span>
                                </div>
                                <div class="col-lg-">
                                    <label class="switch">
                                        <input type="checkbox" formControlName="Status" id="Status"
                                               [checked]="form3.get('Status').value"
                                               (change)="toggleStatuss($event.target.checked)">
                                        <span class="slider"></span>
                                    </label>
                                </div>


                            </div><br /><br />
                            <div class="row" *ngIf="form3.controls['Rolestatus'].value && LoginDetails[0].RoleId === 4 || LoginDetails[0].RoleId !== 4">

                                <div class="col-lg-11">
                                    <span><b><span class="note">Note :</span> Enable or disable the visibility of your phone number to the public for donation</b></span>
                                </div>
                                <div class="col-lg-">
                                    <label class="switch">
                                        <input type="checkbox" formControlName="Statusphn" id="Status"
                                               [checked]="form3.get('Statusphn').value"
                                               (change)="toggleStatuss1($event.target.checked)">
                                        <span class="slider"></span>
                                    </label>
                                </div>


                            </div>

                            <div class="col-lg-4">
                                <label for="username">Full Name<span style="color:red">*</span></label>
                            </div>
                            <div class="col-lg-8">
                                <input type="text" style="" id="username" formControlName="username" placeholder="Donor Full Name" required />
                                <small style="color: red;" class="text-danger" *ngIf="form.controls.username.touched && form.controls.username.errors?.required">Donor Name is required</small>

                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-4">
                                <label for="mobile">Mobile&nbsp;Number<span style="color:red">*</span></label>
                            </div>
                            <div class="col-lg-8">
                                <input type="text" id="mobile" formControlName="mobile" placeholder="Mobile Number" [readonly]="true" />
                                <small style="color:red" class="text-danger" *ngIf="form.controls.mobile.touched && form.controls.mobile.errors?.required">Donor Mobile is required</small>

                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-4">
                                <label for="email">Email<span style="color:red">*</span></label>
                            </div>
                            <div class="col-lg-8">
                                <input type="text" id="email" formControlName="email" placeholder="Email ID" />
                                <small style="color:red" *ngIf="form.controls.email.touched && form.controls.email.errors?.required">Doner Email is Required</small>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-4">
                                <label for="age">Gender<span style="color:red">*</span></label>
                            </div>
                            <div class="col-lg-8">
                                <div class="row">
                                    <div class="col-lg-3 col-xs-6">
                                        <div class="chip1" (click)="selectGender('Male')" [ngClass]="{'selected': selectedGender === 'Male'}" required>Male</div>
                                    </div>
                                    <div class="col-lg-3 col-xs-6">
                                        <div class="chip1" (click)="selectGender('Female')" [ngClass]="{'selected': selectedGender === 'Female'}" required>Female</div>
                                    </div>
                                    <div class="col-lg-4 col-xs-6"></div>
                                </div>

                            </div>



                            <div class="col-lg-4 mt-n2" *ngIf="form3.controls['Rolestatus'].value && LoginDetails[0].RoleId === 4 || LoginDetails[0].RoleId !== 4">
                                <label for="age">Ever donated blood<span style="color:red">*</span></label>
                            </div>
                            <div class="col-lg-8 mt-n2" *ngIf="form3.controls['Rolestatus'].value && LoginDetails[0].RoleId === 4 || LoginDetails[0].RoleId !== 4">
                                <div class="row">
                                    <div class="col-lg-3 col-xs-6">
                                        <div class="chip1" (click)="PastDonation('Yes')" [ngClass]="{'selected': selectedpast === 'Yes'}" required>Yes</div>

                                    </div>
                                    <div class="col-lg-3 col-xs-6">
                                        <div class="chip1" (click)="PastDonation('No')" [ngClass]="{'selected': selectedpast === 'No'}" required>No</div>

                                    </div>
                                    <div class="col-lg-4 col-xs-6"></div>
                                </div>

                            </div>

                            <div class="col-lg-4 mt-n1" *ngIf="selectedpast !== 'No'">
                                <div *ngIf="form3.controls['Rolestatus'].value && LoginDetails[0].RoleId === 4 || LoginDetails[0].RoleId !== 4">
                                    <label>Last donate date<span style="color:red">*</span></label>
                                </div>
                            </div>
                            <div class="col-lg-8 mt-n1" *ngIf="selectedpast !== 'No'">
                                <div *ngIf="form3.controls['Rolestatus'].value && LoginDetails[0].RoleId === 4 || LoginDetails[0].RoleId !== 4">

                                    <div class="input-group">
                                        <input style="padding:6px" formControlName="Lastdonatedate" required type="date" name="Lastdonatedate" id="Lastdonatedate" [readonly]="selectedpast === 'No'">
                                    </div>
                                </div>
                            </div>


                            <div class="col-lg-4 mt-n1" *ngIf="form3.controls['Rolestatus'].value && LoginDetails[0].RoleId === 4 || LoginDetails[0].RoleId !== 4">
                                <label for="mobile">Weight<span style="color:red">*</span></label>
                            </div>
                            <div class="col-lg-8 mt-n1" *ngIf="form3.controls['Rolestatus'].value && LoginDetails[0].RoleId === 4 || LoginDetails[0].RoleId !== 4">
                                <input type="text" id="Weight" formControlName="Weight" placeholder="Weight " oninput="this.value = this.value.replace(/[^0-9]/g, '');" required />
                                <small style="color:red" class="text-danger" *ngIf="form.controls.Weight.touched && form.controls.Weight.errors?.required">Donor Weight is required</small>

                            </div>

                        </div>

                        <div class="row" *ngIf="form3.controls['Rolestatus'].value && LoginDetails[0].RoleId === 4 || LoginDetails[0].RoleId !== 4">
                            <div class="col-lg-4">
                                <label for="age">Age<span style="color:red">*</span></label>
                            </div>
                            <div class="col-lg-8">
                                <input type="text" id="age" formControlName="age" placeholder="Age" oninput="this.value = this.value.replace(/[^0-9]/g, '');" required />
                            </div>
                        </div>

                        <div class="row" *ngIf="form3.controls['Rolestatus'].value && LoginDetails[0].RoleId === 4 || LoginDetails[0].RoleId !== 4">
                            <div class="col-lg-4">
                                <label>Blood Group<span style="color:red">*</span></label>
                            </div>
                            <div class="col-lg-8">
                                <div style="padding-left:0px">

                                    <p-autoComplete formControlName="bloodgroup" [suggestions]="deptList3" (completeMethod)="searchCont3($event)"
                                                    field="BLGName" [dropdown]="true" [size]="90"
                                                    placeholder="Search Blood Group" [minLength]="1"
                                                    [style]="{'color': 'black','border-radius':'5px'}"
                                                    [panelStyle]="{'background-color': 'white','margin-left':'3px','padding':'10px','box-shadow':' rgba(0, 0, 0, 0.24) 0px 3px 8px'}">
                                    </p-autoComplete>
                                    <small *ngIf="form.controls.bloodgroup.touched && form.controls.bloodgroup.errors?.required"
                                           class="p-error">blood group is required.</small>
                                </div>
                            </div>
                        </div>

                        <div class="row">

                            <div class="col-lg-4">
                                <label>State Name</label>
                            </div>
                            <div class="col-lg-8">

                                <div style="padding-left:0px">

                                    <p-autoComplete formControlName="statename" [suggestions]="deptLists" (completeMethod)="searchConts($event)"
                                                    field="StateName" [dropdown]="true" [size]="90" (click)="getDistricts()"
                                                    placeholder="Search State Name" [minLength]="1"
                                                    [style]="{'color': 'black'}"
                                                    [panelStyle]="{'background-color': 'white', 'box-shadow':' rgba(0, 0, 0, 0.24) 0px 3px 8px','margin-left':'3px','padding':'10px','cursor':'pointer',}">

                                    </p-autoComplete>


                                    <small *ngIf="form.controls.statename.touched && form.controls.statename.errors?.required"
                                           class="p-error">State Name is required.</small>
                                </div>

                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-4">
                                <label>District Name</label>
                            </div>
                            <div class="col-lg-8">

                                <div style="padding-left:0px">

                                    <p-autoComplete formControlName="districtname" [suggestions]="deptList1s" (completeMethod)="searchCont1s($event)"
                                                    field="DistrictName" [dropdown]="true" [size]="90" (click)="getCitys()"
                                                    placeholder="Search District Name" [minLength]="1"
                                                    [style]="{'color': 'black'}"
                                                    [panelStyle]="{'background-color': 'white', 'box-shadow':' rgba(0, 0, 0, 0.24) 0px 3px 8px','margin-left':'3px','padding':'10px'}">

                                    </p-autoComplete>

                                    <small *ngIf="form.controls.districtname.touched && form.controls.districtname.errors?.required"
                                           class="p-error">District Name is required.</small>
                                </div>
                            </div>

                        </div>

                        <div class="row">
                            <div class="col-lg-4">
                                <label>City Name</label>
                            </div>
                            <div class="col-lg-8">
                                <div style="padding-left:0px">

                                    <p-autoComplete formControlName="cityname"
                                                    [suggestions]="deptList2s"
                                                    (completeMethod)="searchCont2s($event)"
                                                    field="CityName"
                                                    [dropdown]="true"
                                                    [size]="120"
                                                    placeholder="Search City Name"
                                                    [minLength]="1"
                                                    [style]="{'color': 'black'}"
                                                    [panelStyle]="{'background-color': 'white', 'box-shadow':' rgba(0, 0, 0, 0.24) 0px 3px 8px','margin-left':'3px','padding':'10px',}">
                                    </p-autoComplete>


                                    <small *ngIf="form.controls.cityname.touched && form.controls.cityname.errors?.required"
                                           class="p-error">City Name is required.</small>
                                </div>

                            </div>

                        </div>

                        <div class="row">
                            <div class="col-lg-4">
                                <label for="useraddress">User Address</label>
                            </div>
                            <div class="col-lg-8">
                                <input type="text" id="useraddress" formControlName="useraddress" placeholder="User Address" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-4">
                                <label for="area">Area</label>
                            </div>
                            <div class="col-lg-8">
                                <input type="text" id="area" formControlName="area" placeholder="Area" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-4">
                                <label for="mobile">Pincode<span style="color:red">*</span></label>
                            </div>

                            <div class="col-lg-8">
                                <input type="text" id="Pincode" formControlName="Pincode" placeholder="Pincode " oninput="this.value = this.value.replace(/[^0-9]/g, '');" required />
                                <small style="color:red" class="text-danger" *ngIf="form.controls.Pincode.touched && form.controls.Pincode.errors?.required">Pincode is required</small>

                            </div>
                        </div>

                        <div class="row" *ngIf="form3.controls['Rolestatus'].value && LoginDetails[0].RoleId === 4 || LoginDetails[0].RoleId !== 4">
                            <div class="col-lg-4">
                                <label for="area">Message</label>
                            </div>
                            <div class="col-lg-8">
                                <input type="text" id="Messagetorequester" formControlName="Messagetorequester" placeholder="Message to Blood Requester" />
                            </div>
                        </div>
                        <br />

                        <div class="row">
                            <div class="col-lg-4"></div>
                            <div class="col-lg-7" *ngIf="(LoginDetails[0]?.RoleId === 4) && (LoginDetails[0]?.Rolestatus === false || LoginDetails[0]?.Rolestatus === true)">
                                <span><b><span class="note">Note:</span> Enable or disable to become as a donor</b></span>
                            </div>
                            <div class="col-lg-7" *ngIf="(LoginDetails[0]?.RoleId === 2) && (LoginDetails[0]?.Rolestatus === false || LoginDetails[0]?.Rolestatus === true)">
                                <span><b><span class="note">Note:</span> Enable or disable to become as a Leader</b></span>
                            </div>
                            <div class="col-lg-1" *ngIf="(LoginDetails[0]?.RoleId === 4) && (LoginDetails[0]?.Rolestatus === false || LoginDetails[0]?.Rolestatus === true)">
                                <label class="switch">
                                    <input type="checkbox" formControlName="Rolestatus" id="Status" [checked]="form3.get('Rolestatus').value" (change)="toggleStatuss2($event.target.checked)">
                                    <span class="slider"></span>
                                </label>
                            </div>
                            <div class="col-lg-1" *ngIf="(LoginDetails[0]?.RoleId === 2) && (LoginDetails[0]?.Rolestatus === false || LoginDetails[0]?.Rolestatus === true)">
                                <label class="switch">
                                    <input type="checkbox" formControlName="Rolestatus" id="Status" [checked]="form3.get('Rolestatus').value" (change)="toggleStatuss2($event.target.checked)">
                                    <span class="slider"></span>
                                </label>
                            </div>

                        </div>


                        <div class="row">
                            <div class="col-lg-2 "></div>

                            <div class="col-lg-3 ">
                                <button class="btn cancell" style="width:70%;" onclick="window.location.href = '/blooddonation';">Cancel</button>
                            </div>

                            <div class="col-lg-3 ">
                                <button class="btn updatee" style="width: 70%;">Update</button>
                            </div>



                        </div>
                    </div>
                </form>

                <!--Share your service-------------------->

                <form [formGroup]="form1" (ngSubmit)="AddBanner(form1.value, 1)" *ngIf="isshareFormVisible" class="form_login">
                    <div style="text-align:center"><b>Note:</b>The Uploaded Image Should Appear In The Gallery</div><br />
                    <div >
                        <div class="row">
                            <div class="col-lg-4 mb-1">
                                <label class="label_1" for="category">Category<span style="color:red">*</span></label>
                            </div>
                            <div class="col-lg-8 mb-1">
                                <p-autoComplete formControlName="Category" [suggestions]="deptList3q" (completeMethod)="searchContq3($event)"
                                                field="categoryname" [dropdown]="true" [size]="90"
                                                placeholder="Select Donor category" [minLength]="1"
                                                [style]="{'color': 'black'}"
                                                [panelStyle]="{'background-color': 'white','margin-left':'3px','margin-bottom':'5px','padding':'10px','box-shadow':' rgba(0, 0, 0, 0.24) 0px 3px 8px',}">
                                </p-autoComplete>

                                <small *ngIf="form1.controls.Category.touched && form1.controls.Category.errors?.required"
                                       class="p-error" style="color:red">Donor category is required.</small>

                            </div>
                        </div>

                        <div class="row">

                            <div class="col-lg-4 mt-n1">
                                <label lass="label_1" for="username"> Upload Picture<span style="color:red">*</span></label>
                            </div>
                            <div class="col-lg-8 mt-2">
                                <input style="margin-top:5px" formControlName="GalleryImages" input type="file" (change)="detectFiles3(input2)"
                                       accept="image/*" #input2 class="m-img-upload-btn mt-n1 txtDate input" />

                            </div>
                        </div>

                        <div class="form-group">
                            <div class="row">
                                <div class="col-lg-4 mt-n1">
                                    <label lass="label_1">Date of service<b><span style="color:red;">*</span></b></label>

                                </div>
                                <div class="col-lg-8 mt-2">
                                    <div class="input-group">
                                        <!--<div class="input-group-prepend">
                                <div class="input-group-text">
                                    <i class="typcn typcn-calendar-outline tx-24 lh--9 op-6"></i>
                                </div>
                            </div>-->
                                        <input formControlName="Dateofservice" required="" type="date" name="JoinedOn" id="JoinedOn">
                                    </div>
                                </div>

                            </div>

                        </div>

                        <div class="row">


                            <div class="col-lg-4">
                                <label lass="label_1">State Name<span style="color:red">*</span></label>
                            </div>
                            <div class="col-lg-8">



                                <p-autoComplete formControlName="statename" [suggestions]="deptList" (completeMethod)="searchContss($event)"
                                                field="StateName" [dropdown]="true" [size]="90" (click)="getDistrictss()"
                                                placeholder="Search State Name" [minLength]="1"
                                                [style]="{'color': 'black'}"
                                                [panelStyle]="{'background-color': 'white', 'box-shadow':' rgba(0, 0, 0, 0.24) 0px 3px 8px','margin-left':'3px','padding':'10px','cursor':'pointer',}">

                                </p-autoComplete>

                                <small *ngIf="form1.controls.statename.touched && form1.controls.statename.errors?.required"
                                       class="p-error">State Name is required.</small>

                            </div>



                            <div class="col-lg-4">
                                <label lass="label_1">District Name</label>
                            </div>
                            <div class="col-lg-8">
                                <p-autoComplete formControlName="districtname" [suggestions]="deptList1" (completeMethod)="searchCont1ss($event)"
                                                field="DistrictName" [dropdown]="true" [size]="90" (click)="getCityss()"
                                                placeholder="Search District Name" [minLength]="1"
                                                [style]="{'color': 'black'}"
                                                [panelStyle]="{'background-color': 'white', 'box-shadow':' rgba(0, 0, 0, 0.24) 0px 3px 8px','margin-left':'3px','padding':'10px'}">

                                </p-autoComplete>

                                <small *ngIf="form1.controls.districtname.touched && form1.controls.districtname.errors?.required"
                                       class="p-error">District Name is required.</small>
                            </div>




                            <div class="col-lg-4">
                                <label lass="label_1">City Name</label>
                            </div>
                            <div class="col-lg-8">
                                <p-autoComplete formControlName="cityname"
                                                [suggestions]="deptList2"
                                                (completeMethod)="searchCont2ss($event)"
                                                field="CityName"
                                                [dropdown]="true"
                                                [size]="120"
                                                placeholder="Search City Name"
                                                [minLength]="1"
                                                [style]="{'color': 'black'}"
                                                [panelStyle]="{'background-color': 'white', 'box-shadow':' rgba(0, 0, 0, 0.24) 0px 3px 8px','margin-left':'3px','padding':'10px',}">
                                </p-autoComplete>


                                <small *ngIf="form1.controls.cityname.touched && form1.controls.cityname.errors?.required"
                                       class="p-error">City name is required.</small>


                            </div>



                            <div class="col-lg-4">
                                <label lass="label_1" for="useraddress">Name of institution <!--/ Hospital--><span style="color:red">*</span></label>
                            </div>
                            <div class="col-lg-8">
                                <input type="text" id="Institutionname" formControlName="Institutionname" placeholder="Name of Institution / Hospital" />
                            </div>


                            <div class="col-lg-4 mt-2">
                                <label lass="label_1" for="Message">Message</label>
                            </div>
                            <div class="col-lg-8 mt-2">
                                <textarea id="Message" formControlName="Message" placeholder="Message your personal note"></textarea>


                            </div>
                            <div class="col-lg-4"></div>
                            <div class="col-lg-4">
                                <button class="btn">Submit</button>
                            </div>
                            <div class="col-lg-4"></div>


                        </div>
                    </div>
                </form>

                <!--<div class="marq">

        <marquee *ngIf="!isDonorRegisterClickedd &&!isDonorRegisterClicked && !isRegistrationFormVisible && !isprofileFormVisible && !isshareFormVisible && !isrequestFormVisible"><h6 style="text-align:center;color:red;font-weight:bold">"Be a hero. Donate blood."</h6></marquee>
        <br />    <p class="fade-in-out justified-text" *ngIf="!isDonorRegisterClickedd  && !isDonorRegisterClicked && !isRegistrationFormVisible && !isprofileFormVisible && !isshareFormVisible && !isrequestFormVisible">
            "Blood donation is the real act of humanity. It costs nothing but saves a life!"

        </p>
        <p class="fade-in-out justified-text" *ngIf="!isDonorRegisterClickedd && !isDonorRegisterClicked && !isRegistrationFormVisible && !isprofileFormVisible && !isshareFormVisible && !isrequestFormVisible">
            "Donating blood is not just giving blood, it’s giving life."
        </p>
        <p class="fade-in-out justified-text" *ngIf="!isDonorRegisterClickedd  && !isDonorRegisterClicked && !isRegistrationFormVisible && !isprofileFormVisible && !isshareFormVisible && !isrequestFormVisible">
            "Every drop of blood is like a breath for someone out there. Donate and let them breathe."

        </p>
        <p class="fade-in-out justified-text" *ngIf="!isDonorRegisterClickedd && !isDonorRegisterClicked && !isRegistrationFormVisible && !isprofileFormVisible && !isshareFormVisible && !isrequestFormVisible">
            "Blood donation is not just an act of charity; it is an act of solidarity."
        </p>
        <p class="fade-in-out justified-text" *ngIf="!isDonorRegisterClickedd && !isDonorRegisterClicked && !isRegistrationFormVisible && !isprofileFormVisible && !isshareFormVisible && !isrequestFormVisible">
            "Be a hero, give blood and save lives."
        </p>
    </div>-->

            </div>

            <div class="col-lg-3">
                <div class="cards" style="cursor: default;padding: 6px;">
                    CURRENT BLOOD REQUESTS
                </div><br />
                <div>
                    <div style=" height: 233px; overflow-y: scroll;">
                        <div *ngFor="let item of Requestdata">
                            <div class="text_move" style="margin-right: 0px; float: none; margin-bottom: 0px;">
                                <p (click)="viewDetails(item.UdId)" class="movetext" style="font-size: 12px;line-height: 28px;cursor:pointer">
                                    <span style="font-weight:bold"> ({{item.BLGName}})&nbsp;{{item.StateName}}</span>,&nbsp;{{item.CityName}}({{item.BloodRequestDate | date:'dd-MMM-yy'}})
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <br /><br /><br />

        
                <div class="cards Gal" (click)="Gallery()">
                    Let's Help Gallery
                </div>
                <br />
                <div class="card_img">
                    <div class="disclaimer-outer">
                        <div class="disclaimer-inner">
                            <!--<div>
                <div style="height: 250px;overflow-y: scroll;">-->
                            <div style="margin-right: 0px; float: none; margin-bottom: 0px;" *ngFor="let item of GallaryCategory12">
                                <a routerLink="/Gallery" target="_self" href="{{HomeUrl+item.GalleryImages}}" class="img_g">
                                    <img src="{{HomeUrl+item.GalleryImages}}" alt="" class="img_g" />
                                </a>
                                <div class="cards">{{item.categoryname}}</div>

                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </div>
    </div>


    <div class="container">

     
        <div class="modal" id="myModal">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header state modal-primary">
                        <h4 class="title" id="modal-primary-label">
                            Request Person Details
                        </h4>

                        <button type="button" class="close" (click)="close()" data-dismiss="modal" aria-label="Close"><span aria-hidden="true" style="color:white;">X</span></button>
                    </div>
                    <div class="modal-body">
                        <div class="container">
                            <div class="card_1">
                                <div class="row">
                                    <div>
                                        <fieldset>
                                            <div class="row">
                                                <div class="col-lg-2 col-md-3 col-sm-3 col-xs-3">
                                                    <div class="tag_heading1"><b>Patient Name</b></div>
                                                </div>

                                                <div class="col-lg-4 col-md-3 col-sm-3 col-xs-3">

                                                    <div class="tag_heading1"><span class="space1">:</span> {{FullName}}</div>
                                                </div>

                                                <div class="col-lg-2 col-md-3 col-sm-3 col-xs-3">
                                                    <div class="tag_heading1"><b>Contact Person</b></div>
                                                </div>

                                                <div class="col-lg-4 col-md-3 col-sm-3 col-xs-3">
                                                    <div class="tag_heading1"><span class="space1">:</span> {{ContactPerson}}</div>
                                                </div>

                                                <div class="col-lg-2 col-md-3 col-sm-3 col-xs-3">
                                                    <div class="tag_heading1"><b>Attender Number</b></div>
                                                </div>

                                                <div class="col-lg-4 col-md-3 col-sm-3 col-xs-3">
                                                    <div class="tag_heading1"><span class="space1">:</span> {{ContactMobile}}</div>
                                                </div>

                                                <!--<a href="tel:{{ContactMobile}}">{{ContactMobile}}</a>-->
                                                <div class="col-lg-2 col-md-3 col-sm-3 col-xs-3">
                                                    <div class="tag_heading1"><b>Blood Group</b></div>


                                                </div>

                                                <div class="col-lg-4 col-md-3 col-sm-3 col-xs-3">
                                                    <div class="tag_heading1"><span class="space1">:</span> {{BLGName}}</div>
                                                </div>

                                                <div class="col-lg-2 col-md-3 col-sm-3 col-xs-3">
                                                    <div class="tag_heading1"><b>Gender</b></div>
                                                </div>

                                                <div class="col-lg-4 col-md-3 col-sm-3 col-xs-3">
                                                    <div class="tag_heading1"><span class="space1">:</span> {{Gender}}</div>
                                                </div>

                                                <div class="col-lg-2 col-md-3 col-sm-3 col-xs-3">
                                                    <div class="tag_heading1"><b>Age</b></div>
                                                </div>

                                                <div class="col-lg-4 col-md-3 col-sm-3 col-xs-3">
                                                    <div class="tag_heading1"><span class="space1">:</span> {{Age}}</div>
                                                </div>

                                                <div class="col-lg-2 col-md-3 col-sm-3 col-xs-3">
                                                    <div class="tag_heading1"><b>Purpose</b></div>
                                                </div>

                                                <div class="col-lg-4 col-md-3 col-sm-3 col-xs-3">
                                                    <div class="tag_heading1"><span class="space1">:</span> {{Purpose}}</div>
                                                </div>

                                                <div class="col-lg-2 col-md-3 col-sm-3 col-xs-3">
                                                    <div class="tag_heading1"><b>Doctor Name</b></div>
                                                </div>

                                                <div class="col-lg-4 col-md-3 col-sm-3 col-xs-3">
                                                    <div class="tag_heading1"><span class="space1">:</span> {{DoctorName}}</div>
                                                </div>

                                                <div class="col-lg-2 col-md-3 col-sm-3 col-xs-3">
                                                    <div class="tag_heading1"><b>Hospital Name</b></div>
                                                </div>

                                                <div class="col-lg-4 col-md-3 col-sm-3 col-xs-3">
                                                    <div class="tag_heading1"><span class="space1">:</span> {{HospitalName}}</div>
                                                </div>
                                                <div class="col-lg-2 col-md-3 col-sm-3 col-xs-3">
                                                    <div class="tag_heading1"><b>Hospital Address</b></div>
                                                </div>

                                                <div class="col-lg-4 col-md-3 col-sm-3 col-xs-3">
                                                    <div class="tag_heading1"><span class="space1">:</span> {{HospitalAddress}}</div>
                                                </div>

                                                <div class="col-lg-2 col-md-3 col-sm-3 col-xs-3">
                                                    <div class="tag_heading1"><b>Hospital Number</b></div>
                                                </div>

                                                <div class="col-lg-4 col-md-3 col-sm-3 col-xs-3">
                                                    <div class="tag_heading1"><span class="space1">:</span> {{HospitalPhonenumber}}</div>
                                                </div>
                                                <div class="col-lg-2 col-md-3 col-sm-3 col-xs-3">
                                                    <div class="tag_heading1"><b>State</b></div>
                                                </div>

                                                <div class="col-lg-4 col-md-3 col-sm-3 col-xs-3">
                                                    <div class="tag_heading1"><span class="space1">:</span> {{StateName}}</div>
                                                </div>

                                                <div class="col-lg-2 col-md-3 col-sm-3 col-xs-3">
                                                    <div class="tag_heading1"><b>District</b></div>
                                                </div>

                                                <div class="col-lg-4 col-md-3 col-sm-3 col-xs-3">
                                                    <div class="tag_heading1"><span class="space1">:</span> {{DistrictName}}</div>
                                                </div>
                                                <div class="col-lg-2 col-md-3 col-sm-3 col-xs-3">
                                                    <div class="tag_heading1"><b>City</b></div>
                                                </div>

                                                <div class="col-lg-4 col-md-3 col-sm-3 col-xs-3">
                                                    <div class="tag_heading1"><span class="space1">:</span> {{CityName}}</div>
                                                </div>


                                                <!--<div class="col-lg-6 col-md-3 col-sm-3 col-xs-3">
                                                    <div class="tag_heading1">State</div>
                                                    <div class="tag_text">{{StateName}}</div>
                                                </div>-->

                                            </div>
                                        </fieldset>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <br />   <br />   <br />

    <div class="footer">
        <div class="container-fluid" style="background-color:black;padding:10px;margin-top:1rem;color:white;">
            <div class="container">
                <div class="row">
                    <div class="col-lg-3">
                        <div>&copy; 2024 Let's Help All Rights Reserved</div>
                    </div>
                    <div class="col-lg-5">
                    </div>
                    <div class="col-lg-1 zoom-in">
                        <a routerLink="/"> <div>Home</div></a>
                    </div>
                    <div class="col-lg-1 zoom-in">
                        <a routerLink="/about"> <div>About Us</div></a>
                    </div>
                    <div class="col-lg-1 zoom-in">
                        <a routerLink="/"> <div>FAQ's</div></a>
                    </div>
                    <div class="col-lg-1 zoom-in">
                        <a routerLink="/contact"> <div>Contact Us</div></a>
                    </div>

                </div>
            </div>
        </div>
    </div>






</div>
<style>





    .icon {
        height: 57%;
        width: 21%;
        border-radius: 23px;
        margin-top: 4px;
        float: inline-end;
    }

    body {
        overflow-x: hidden;
        max-width: 100%
    }

    .ptb-100 {
        overflow-y: auto; /* Enable vertical scrolling */
        max-height: 100vh; /* Limit the maximum height to ensure it fits within the viewport */
    }

    a {
        color: white;
    }

    .modal-dialog {
        max-width: 60% !important;
        margin: 1.75rem auto !important;
        color: #7f0207;
    }

    .card {
        box-shadow: 0 3px 5px rgba(0, 0, 0, 0.11), 0 3px 6px rgba(0, 0, 0, 0.02);
    }

    /*  input {
        width: 19.5rem;
    }*/

    .blood {
        color: black;
    }

    @media only screen and (max-width: 767px) {
        .modal-dialog {
            max-width: 100% !important;
            margin: 1.75rem auto !important;
            color: #7f0207;
        }
    }

    .hover {
        display: none;
        position: absolute;
        background-color: #f9f9f9;
        /*width: 180%;*/
        box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
        z-index: 1;
    }

        .hover h {
            color: black;
            padding: 5px;
            text-decoration: none;
            display: block;
            text-align: left;
        }

            .hover h:hover {
                background-color: rgba(0,0,0,0.2);
            }

    .dropdown:hover .dropdown-content {
        display: block;
    }
</style>
